import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePopularUsers } from '../../../../../react-query/user/usePopularUsers';

import { NoItemsText } from '../../../../profile/components/ProfileData/components';
import { NewsFeedProfileCard } from '../components/NewsFeedProfileCard';
import { NewsFeedCardBase, NewsFeedTitle } from '../components/shared';
import { NewsFeedGrid } from '../components/NewsFeedGrid';

import { routes } from '../../../../../router/routes';

export const PopularUsersSection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isLoading, error } = usePopularUsers();

  const renderContent = () => {
    if (error) return <NoItemsText isError>{t('errors.default')}</NoItemsText>;

    if (!data) return null;

    return data.map(({ photoUrl, username, followersCount }) => (
      <NewsFeedProfileCard
        key={username}
        photoUrl={photoUrl}
        title={username}
        followersCount={followersCount}
        onClick={() => navigate(routes.profile.byId(username))}
      />
    ));
  };

  return (
    <NewsFeedCardBase>
      <NewsFeedTitle>{t('homePage.mostFollowed')}</NewsFeedTitle>
      <NewsFeedGrid isLoading={isLoading}>{renderContent()}</NewsFeedGrid>
    </NewsFeedCardBase>
  );
};
